import { Fragment } from "react";

import {
  VIEWPORT_TOOLSET_PLACEMENTS,
} from "@/viewport-tools/core";
import type { ViewportToolsetId } from "@/viewport-tools/core/contracts";
import {
  DocumentViewportLeftRail,
  DocumentViewportRailGroup,
} from "@/features/document-viewport/toolbar";
import { VIEWPORT_TOOLSET_DEFINITIONS } from "@/viewport-tools/registry";
import { collectViewportToolsetRailRendererResults } from "@/viewport-tools/rail/renderers";
import type { ViewportToolsetsRailProps } from "@/viewport-tools/rail/types";

const DEFAULT_LEFT_RAIL_TOOLSETS: ViewportToolsetId[] = VIEWPORT_TOOLSET_DEFINITIONS.filter(
  (toolset) => toolset.placement === VIEWPORT_TOOLSET_PLACEMENTS.leftRail
).map((toolset) => toolset.id as ViewportToolsetId);

export function ViewportToolsetsRail({
  enabledToolsets = DEFAULT_LEFT_RAIL_TOOLSETS,
  controllers,
}: ViewportToolsetsRailProps) {
  const rendererResults = collectViewportToolsetRailRendererResults(
    enabledToolsets,
    controllers
  );

  const inlineContent = rendererResults.some((result) => result.inlineContent) ? (
    <>
      {rendererResults.map((result, index) =>
        result.inlineContent ? (
          <Fragment key={`inline-${result.item?.id ?? index}`}>
            {result.inlineContent}
          </Fragment>
        ) : null
      )}
    </>
  ) : undefined;

  if (!inlineContent) {
    return null;
  }

  return (
    <DocumentViewportLeftRail>
      <DocumentViewportRailGroup>{inlineContent}</DocumentViewportRailGroup>
    </DocumentViewportLeftRail>
  );
}

export type { ViewportToolsetsRailProps };
